import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import Pagination from './../../../../shared/components/pagination';
import Report from '../../../services/report.service';
import Util from '../../../../shared/util/util'
import Loader from './../../../../shared/components/loader'
import XLSX from 'xlsx';
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import DatePicker from 'vue2-datepicker';
export default {
  name: 'printstickerlog',
  components: {
    Pagination,
    VueElementLoading,
    Loader,
	  DatePicker,	 
  },
  props: [],
  data() {
    return {
      StickerType:'',
      parentMPS: '',
      PrintStickerFromDate:null,
      PrintStickerToDate:null,
      awb:"",
      mps:"",
      printstickerfromdate:"",
      printstickertodate:"",
      tableArr :'',
      totalCount:',',
      printStickerData:null,
      currentTab:'First',
      currentPage: 1,
      TotalData:[],
      cnt:1,
      isLoading:false,
      totalPage: 0,
      totalAwbPage:0,
      totalCount:0,
      offset:0,
      pageLimit:10,
      printStickerTrack:false,
      StikerErr:'',
      idx:1,
      printAWBTrack:false,
      PrintAWBFromDate:null,
      PrintAWBToDate:null,
      printawbfromdate:"",
      printawbtodate:"",
      poawb:'',
      POAwb:'',
      FromDateErr:'',
      ToDateErr:'',
      MainErr:'',
      startdate:'',
      enddate:'',
      TotalAwbData:[],
      totalAwbCount:0,
      PrintAWBFromDateError:false,
      PrintAWBToDateError:false,
      todaysDate: '',
      validDateRange: '',
      validDateRangeFrom: '',
      todaysDate1: '',
      validDateRange1: '',
      validDateRangeFrom1: '',
      selectedStartDate:'',
      PrintStickerFromDateError:false,
      PrintStickerToDateError:false,
      todaysDate: '',
      validDateRange: '',
      validDateRangeFrom: '',
      todaysDate2: '',
      validDateRange2: '',
      validDateRangeFrom2: '',
      selectedFromDate:'',
      currentAwbPage:1,
      awbError:'',
      mpsError:'',
      showMPS:false,
      modalData:'',
    }
  },
  computed: {
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment.utc(date).format('DD-MM-YYYY HH:mm:ss');
    },
  },
  async mounted() {
      var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.hubId = userdetail.hubID[0];
      this.todaysDate1 = moment().format('YYYY-MM-DD');
      this.todaysDate2 = moment().format('YYYY-MM-DD');
      await this.searchFilter();
  },
  methods: {
    displayMPS(data){
      this.modalData=data.mpsdata.join(", ");
      this.showMPS = true
    },
    searchFilter(){
      this.currentPage = 1;
      this.printStickerTrack=true;
      this.offset = 0;
      this.getprintstickersummarydata();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getprintstickersummarydata();
    },
    resetSearch(){
      this.StikerErr='';
      this.StickerType='';
      this.idx=1;
      this.currentPage = 1;
      this.printStickerTrack=false;
      this.Error=null;
      this.PrintStickerFromDate=null;
      this.PrintStickerToDate=null;
      this.parentMPS='';
      this.getprintstickersummarydata();
      this.FromDateErr = '';
      this.ToDateErr = '';
    },
      async validateParentAwbNo(parentAwbNo) {
      return new Promise((resolve, reject) => {
        try {
          let regexSurface = new RegExp('^9');
          let regexAir = new RegExp("^7|^7167");
          let reverseAwb = new RegExp("R_", "i");
          let regexAirAsia = new RegExp("^I5", "i");
          let regexGoAir = new RegExp("^G8", "i");
          let regexJetAirways = new RegExp("^9W", "i");
          let regexVistara = new RegExp("^UK", "i");
          let regexSpiceJet = new RegExp("^SG", "i");
          let regexAirIndia = new RegExp("^AI", "i");
          let regexGoAirCosta = new RegExp("^LB", "i");
          let regexBlueDart = new RegExp("^BZ", "i");
          let regexIndigo = new RegExp("^6E", "i");
          if (parentAwbNo != "") {
          if (parentAwbNo.length >= 9 && parentAwbNo.length <= 16) {
            if (regexSurface.test(parentAwbNo) || regexAir.test(parentAwbNo) || regexAirAsia.test(parentAwbNo) || regexGoAir.test(parentAwbNo) ||
            regexJetAirways.test(parentAwbNo) || regexVistara.test(parentAwbNo) || regexSpiceJet.test(parentAwbNo) || regexAirIndia.test(parentAwbNo)
            || regexGoAirCosta.test(parentAwbNo) || regexBlueDart.test(parentAwbNo) || reverseAwb.test(parentAwbNo) || regexIndigo.test(parentAwbNo)) {
              return resolve({ status: true, message: "" })
            } else {
              return resolve({ status: false, message: "AWB Series does not match, AWB series for surface - (9) and Air - (7, 9W, G8, UK, SG, AI, LB, BZ, 6E, I5)" })
            }
            } else {
              return resolve({ status: false, message: "Invalid AWB No. (AWB No. must be min 10 or max 16 digit)" })
            }
          } else {
            return resolve({ status: false, message: "AWB No Is Required." })
          }
        } catch (error) {
          reject("ERROR", error);
        }
      })
    },
    async getprintstickersummarydata(flag){
      try {
        if(await this.checkErr(2) == 1){
          this.printStickerTrack=false;
          return false
        }
        this.StikerErr='';
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        if(flag==1)
        {
          inputPayload.limit=30;
        }
        if(this.StickerType=="AWB"){
          inputPayload.awb = this.parentMPS.toUpperCase().trim();
        }
        if(this.StickerType=="MPS"){
          inputPayload.mps = this.parentMPS.toUpperCase().trim();
        }
        if(this.Error){
          inputPayload.error = this.Error;
        }
        if(this.PrintStickerFromDate!=null){
          inputPayload.createddatefrom = (this.PrintStickerFromDate);
        }
        if(this.PrintStickerToDate!=null){
          inputPayload.createddateto = (this.PrintStickerToDate);
        }
        let result = await Report.getprintmpslogs(inputPayload)
        if ( result.data.code == 200 && result.data.data!=null) {
          this.totalCount=result.data.data.count;
          this.TotalData=result.data.data.data;
        }
        else{
          this.totalCount=0;
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
        return result;
      }
      catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    checkToDate() {
      this.PrintStickerToDate = null;
      this.todaysDate2 = moment().format('YYYY-MM-DD');
      this.selectedFromDate = moment.utc(this.PrintStickerFromDate).format("YYYY-MM-DD").valueOf();
      let result =  moment().diff(this.selectedFromDate, 'days')
      if(result>6){
        this.selectedDate = moment(this.selectedFromDate).add(6, 'days').format('YYYY-MM-DD').valueOf();
      }else{
        this.selectedDate = this.todaysDate2
      }
      if (this.selectedFromDate <= this.todaysDate2 && this.selectedFromDate <= this.selectedDate) {
        this.validDateRange2 = this.selectedDate
        this.PrintStickerFromDateError = false
      } else {
        this.validDateRange2 = this.todaysDate2
        this.PrintStickerFromDateError = false
      }
      if (this.PrintStickerFromDate != null) { this.PrintStickerFromDateError = false }
    },
    checkFromDate() {
      this.selectedDate = moment(this.selectedFromDate).add(6, 'days').format('YYYY-MM-DD').valueOf();
      this.validDateRangeFrom2 = moment.utc(this.PrintStickerToDate).format("YYYY-MM-DD").valueOf();

      if (this.PrintStickerToDate > this.selectedDate) {
        this.$alertify.error("Please select date range should be less than or equal to 7 Days")
        this.PrintStickerToDate = null;
      }
      if (this.PrintStickerToDate != null) { this.PrintStickerToDateError = false }
      if (this.PrintStickerToDate > this.todaysDate2) {
        this.$alertify.error("You can't select more than todays date")
        this.PrintStickerToDate = null;
      }
    },
    async checkErr(flag){
      let err = 0
      if(flag==2)
      {
      this.startdate=this.PrintStickerFromDate
      this.enddate=this.PrintStickerToDate
      if (!this.parentMPS) {
        if (this.StickerType == "AWB") {
          this.StikerErr = "Please Enter AWB";
          err = 1;
        } else if (this.StickerType == "MPS") {
          this.StikerErr = "Please Enter MPS";
          err = 1;
        }
      }else if(this.parentMPS) {
        if (this.StickerType == "AWB") {
          await this.validateParentAwbNo(
          this.parentMPS.toUpperCase().trim()
          ).then((awbValidationResult) => {
          if (!awbValidationResult.status) {
            this.awbError = awbValidationResult.message;
            this.$alertify.error(this.awbError);
            err = 1;
            }
          });
        } else if (this.StickerType == "MPS") {
          await this.validateChildMpsNo(
            this.parentMPS.toUpperCase().trim()
          ).then((mpsValidationResult)=>{
            if (!mpsValidationResult.status) {
              this.mpsError = mpsValidationResult.message;
              this.$alertify.error(this.mpsError);
              err = 1;
            }
          })
        }
      } else{
        this.StikerErr = "";
      }
      }else{
        this.StikerErr = "";
      }
      return err
    },
    async exportData() {
      try {
        let inputPayload = {
          "offset": 0,
          "limit": this.totalCount,
        }
        if(this.StickerType=="AWB"){
          inputPayload.awb = this.parentMPS.toUpperCase().trim();
        }
        if(this.StickerType=="MPS"){
          inputPayload.mps = this.parentMPS.toUpperCase().trim();
        }
        if(this.Error){
          inputPayload.error = this.Error;
        }
        if(this.PrintStickerFromDate!=null){
          inputPayload.createddatefrom = (this.PrintStickerFromDate);
        }
        if(this.PrintStickerToDate!=null){
          inputPayload.createddateto = (this.PrintStickerToDate);
        }

        let data = await Report.getprintmpslogs(inputPayload)
        this.isLoading = true;
        if (data && data.data.code == 200) {
          var tempdata = [];
          var temp=data.data.data.data;
          if(temp.length>0)
          {
            temp.forEach(el=> {
              tempdata.push({
                'Awb': el.awb,
                'MPS':el.mpsdata.join(", "),
                'Loggedinhubid':el.loggedinhubid,
                'Hub Name':el.hubname,
                'User Id':el.userid,
                'User Email': el.useremail,
                'Created Date':el.createddate,
                'Source Type':el.source,
                'Print Type':el.printtype,
              });
            });
          }
          else{
            this.$alert(data.data.message, "", "error");
          }
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data1 = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data1, 'data')
          XLSX.writeFile(wb, dt + '_printStickerLog.xlsx');
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    async validateChildMpsNo(childMpsNo) {
      return new Promise((resolve, reject) => {
        try {
          let regexSurface = new RegExp('^MPS|^S', 'i')
          let regexSurfaceAir = new RegExp('^MPA|^A', 'i')
          let regexSurfaceReverseMps = new RegExp("R_MPS", "i")
          let regexSurfaceAirReverseMps = new RegExp("R_MPA", "i")
          if (childMpsNo != '') {
            if (childMpsNo.length > 3) {
              if (regexSurface.test(childMpsNo) || regexSurfaceAir.test(childMpsNo)|| regexSurfaceReverseMps.test(childMpsNo)|| regexSurfaceAirReverseMps.test(childMpsNo)) {
                return resolve({ status: true, message: "" })
              } else {
                return resolve({ status: false, message: "MPS Series does not match, MPS Series For Surface - (MPS) and Air - (MPA)" })
              }
            } else {
              return resolve({ status: false, message: "MPS No Is Invalid" })
            }
          } else {
            return resolve({ status: false, message: "MPS No Is Requires" })
          }
        } catch (error) {
          reject("ERROR", error);
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/PrintingLog/printstickerlog/printstickerlog.component.js